import * as React from "react";
import { ComponentType } from "./ComponentType.js";
import * as cls from "./TextCard.module.scss";
const cType = new ComponentType("TextCard", "text_card_", cls);
export { TextCard };
/**
 * Простая текстовая карточка.
 *
 * По мере необходимости, будут созданы компоненты аналогичные карточкам
 * Bootstrap (см. [Карточки][1]).
 *
 * [1]: https://bootstrap-4.ru/docs/5.3/components/card/
 *
 * Пока реализована только простая текстовая карточка.
 *
 * @summary Простая текстовая карточка.
 * @param {Object} props - Атрибуты элемента.
 * @param {"primary"|"warning"|"danger"|"success"|"fail"|"default"} [props.type=default] - Тип карточки.
 * @param {string} [props.label] - Надпись.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {JSX.Element} props.children - Содержимое.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * <TextCard type="primary" className="my_class">Содержимое</TextCard>
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function TextCard(
  {
    type = "default",
    label,
    className,
    children
  }) {
  const fullClassName = cType.getFullClassName(type, className);
  const labelView = label ?
    <div className={cls.text_card_label}>{label}</div> :
    null;
  return (
    <div className={fullClassName}>
      {labelView}{children}
    </div>
  );
}
/**
 * Типы карточек.
 * @enum {string}
 * @inner
 */
TextCard.Type =
{
  /** Основная карточка. Цвет фона: `$primary_background`. */
  PRIMARY: "primary",
  /** Предупреждение. */
  WARNING: "warning",
  /** Красная карточка. Сообщение об ошибке или опасности. */
  DANGER: "danger",
  /** Сообщение о положительном результате. */
  SUCCESS: "success",
  /** Сообщение об отрицательном результате. */
  FAIL: "fail",
  /** По умолчанию прозрачный фон. */
  DEFAULT: "default"
};
